/**
 * Firmas de las notas y su perfil publico.
 *
 * El campo `author` del frontmatter es texto libre; aca se resuelve a donde
 * lleva cada firma. Las firmas de equipo ("Equipo WAIA", "WAIA Team", "WAIA")
 * llevan al perfil de la empresa; las personas, a su propio perfil. Una firma
 * sin perfil conocido se muestra como texto, sin enlace.
 */

export const WAIA_INSTAGRAM = "https://www.instagram.com/somoswaia/";

const TEAM_AUTHOR = /^(equipo\s+waia|waia(\s+team)?)$/i;

/** Clave: nombre en minusculas y sin tildes. */
const PEOPLE_PROFILES: Record<string, string> = {
  "matias rotoloni": "https://www.instagram.com/matiroto/",
  "harald valdivieso": "https://www.instagram.com/haraldv_/",
};

function normalize(name: string): string {
  return name
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .trim()
    .toLowerCase();
}

/** True si dos firmas son la misma persona (sin distinguir tildes ni mayusculas). */
export function isSameAuthor(a: string, b: string): boolean {
  return normalize(a) === normalize(b);
}

/** True si la firma representa a la empresa y no a una persona. */
export function isTeamAuthor(name: string): boolean {
  return TEAM_AUTHOR.test(name.trim());
}

/** URL del perfil de la firma, o undefined si no hay uno conocido. */
export function authorProfileUrl(name: string): string | undefined {
  if (isTeamAuthor(name)) return WAIA_INSTAGRAM;
  return PEOPLE_PROFILES[normalize(name)];
}
